import React, { useState } from 'react';
import Sidebar from '../setting/Sidebar';
import { default as MainLayout } from '../Layout';

const Layout = ({ children }) => {
  const [isSettingSidebarOpen, setIsSettingSidebarOpen] = useState(false);

  return (
    <MainLayout>
      <div className="flex flex-col lg:flex-row relative min-h-screen">
        {/* Mobile Overlay */}
        {isSettingSidebarOpen && (
          <div 
            className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40 lg:hidden"
            onClick={() => setIsSettingSidebarOpen(false)}
          />
        )}

        {/* Settings Sidebar */}
        <div className={`
          fixed lg:sticky lg:top-0 
          ${isSettingSidebarOpen ? 'left-0' : '-left-full'}
          lg:left-0 
          z-50 lg:z-0
          transition-all duration-300 ease-in-out
          h-screen lg:h-auto
        `}>
          <Sidebar 
            isOpen={isSettingSidebarOpen}
            toggleSidebar={() => setIsSettingSidebarOpen(!isSettingSidebarOpen)}
          />
        </div>

        {/* Main Content Area */}
        <div className="flex-grow flex flex-col lg:ml-4">
          {/* Mobile Toggle Button */}
          <button
            className="lg:hidden fixed bottom-10 left-4 z-10 
              bg-tblue text-white p-2 rounded-full shadow-lg 
              hover:bg-accent transition-all duration-300"
            onClick={() => setIsSettingSidebarOpen(true)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>

          <div className="flex-grow  overflow-y-auto">
            {children}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Layout;
